module.exports = __webpack_public_path__ + "img/logo-m2n.f0e5256b.svg";